/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// app: services
import assets from 'services/assets';

// assets
import CssEmptyShelf from './EmptyShelf.scss';

function EmptyShelf({ height, userSpecific }) {
  useStyles(CssEmptyShelf);
  const { t } = useTranslation();
  const style = {
    backgroundImage: `-webkit-image-set(
        url(${assets.backdropUrl('bookgrid.jpg', {
          resize: 'fit-in',
          width: 1024,
          height: 768,
        })}) 1x,
        url(${assets.backdropUrl('bookgrid.jpg', {
          resize: 'fit-in',
          width: 2048,
          height: 1536,
        })}) 2x
      )`,
    height,
  };
  return (
    <div className="empty-shelf" style={style}>
      <div className="empty-shelf__fade">
        <div className="empty-shelf__body">
          {userSpecific ? (
            <p>
              As you use ckbk, add {t('favorites')} and create collections, we&apos;ll show your top
              books here so they are easy to get&nbsp;to.
            </p>
          ) : (
            <p>There&apos;s nothing here right now, but check back soon...</p>
          )}
        </div>
      </div>
    </div>
  );
}

EmptyShelf.propTypes = {
  height: PropTypes.number,
  userSpecific: PropTypes.bool,
};

EmptyShelf.defaultProps = {
  height: 250,
  userSpecific: false,
};

export default React.memo(EmptyShelf);
